/*
  <stelbo-faq> — animeaza deschiderea/inchiderea elementelor <details>.

  Problema pe care o rezolva: browserul comuta `open` instantaneu, deci
  inchiderea nu se poate anima direct. Solutia e sa amanam stergerea
  atributului `open` pana la finalul tranzitiei; deschiderea, in schimb,
  are nevoie de `open` PUS inainte, altfel continutul nu are inaltime de
  animat.

  Animatia merge pe `grid-template-rows: 0fr -> 1fr`, deci nu exista plafon
  de inaltime si nu trebuie masurat nimic din JS.

  Totul e scope-uit la `this`, nu la `document`: doua sectiuni FAQ in aceeasi
  pagina nu se mai influenteaza reciproc.
*/
(function () {
  if (customElements.get('stelbo-faq')) return;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  class StelboFaq extends HTMLElement {
    connectedCallback() {
      this.items = Array.prototype.slice.call(
        this.querySelectorAll('.st-faq__item')
      );
      if (!this.items.length) return;

      this.single = this.dataset.single === 'true';
      this.classList.add('st-faq--enhanced');

      var self = this;
      this.items.forEach(function (item) {
        var summary = item.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', function (e) {
          e.preventDefault();
          self.toggle(item);
        });
      });
    }

    toggle(item) {
      if (item.dataset.animating === 'true') return;

      if (item.open) {
        this._close(item);
      } else {
        if (this.single) this._closeOthers(item);
        this._open(item);
      }
    }

    _closeOthers(keep) {
      var self = this;
      this.items.forEach(function (item) {
        if (item !== keep && item.open) self._close(item);
      });
    }

    _open(item) {
      item.open = true;
      if (REDUCED.matches) {
        item.classList.add('is-open');
        return;
      }
      item.dataset.animating = 'true';
      // Un cadru de asteptare: fara el, browserul aplica starea finala
      // odata cu `open` si nu mai are de la ce sa porneasca tranzitia.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          item.classList.add('is-open');
          StelboFaq.after(item, function () {
            item.dataset.animating = 'false';
          });
        });
      });
    }

    _close(item) {
      if (REDUCED.matches) {
        item.classList.remove('is-open');
        item.open = false;
        return;
      }
      item.dataset.animating = 'true';
      item.classList.remove('is-open');
      StelboFaq.after(item, function () {
        item.open = false;
        item.dataset.animating = 'false';
      });
    }

    /* Asteapta finalul tranzitiei de pe panoul de raspuns, cu plasa de
       siguranta daca `transitionend` nu ajunge (tab ascuns, de exemplu). */
    static after(item, done) {
      var panel = item.querySelector('.st-faq__a');
      if (!panel) { done(); return; }

      var finished = false;
      var finish = function () {
        if (finished) return;
        finished = true;
        panel.removeEventListener('transitionend', onEnd);
        clearTimeout(timer);
        done();
      };
      var onEnd = function (e) {
        if (e.target === panel && e.propertyName === 'grid-template-rows') finish();
      };

      panel.addEventListener('transitionend', onEnd);
      var timer = setTimeout(finish, 600);
    }
  }

  customElements.define('stelbo-faq', StelboFaq);
})();
